<template>
  <div class="p-2">
    <vs-row style="align-items: center">
      <h4 class="text-w text-gray">{{ header }}</h4> </vs-row
    ><br />

    <!-- <pre>{{data}}</pre> -->
    <vs-table max-items="10" pagination :data="data">
      <template slot="thead">
        <vs-th v-if="type == 'warehouse'" align="center"> </vs-th>
        <vs-th align="center" v-for="i in tableheader" :key="i">
          {{ i }}
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td v-if="type == 'warehouse'">
            <vs-button color="danger" type="flat" icon="remove"
              >remove</vs-button
            >
          </vs-td>
          <vs-td> {{ tr.id }} </vs-td>

          <vs-td> E2000017591900640930BB5B </vs-td>

          <vs-td> E2000017591900640930BB5B </vs-td>

          <vs-td> 1000HH0321100008 </vs-td>

          <vs-td> 54 </vs-td>
          <vs-td> 1 </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  props: ["type", "header", "tableheader"],
  data() {
    return {
      maxheight: "700px",
      header2: {
        header: ["Timestamp", "Tag Name", "EQC", "RSSI", "Serial No.", "Count"],
        keys: ["data_2", "id", "data_1", "data_2", "data_3", "id", "data_1"],
      },
      data: [
        {
          id: "2021-02-24 08:00:00",
          data_1: "1.77 hr",
          data_2: "2.34 hr",
          data_3: "2.14 hr",
        },
        {
          id: "2021-02-24 08:00:00",
          data_1: "1.77 hr",
          data_2: "2.11 hr",
          data_3: "2.14 hr",
        },
        {
          id: "2021-02-24 08:00:00",
          data_1: "1.77 hr",
          data_2: "1.89 hr",
          data_3: "1.14 hr",
        },
        {
          id: "2021-02-24 08:00:00",
          data_1: "1.77 hr",
          data_2: "2.34 hr",
          data_3: "2.14 hr",
        },
        {
          id: "2021-02-24 08:00:00",
          data_1: "1.77 hr",
          data_2: "2.11 hr",
          data_3: "2.14 hr",
        },
        {
          id: "2021-02-24 08:00:00",
          data_1: "1.77 hr",
          data_2: "1.89 hr",
          data_3: "1.14 hr",
        },
        {
          id: "2021-02-24 08:00:00",
          data_1: "1.77 hr",
          data_2: "2.34 hr",
          data_3: "2.14 hr",
        },
        {
          id: "2021-02-24 08:00:00",
          data_1: "1.77 hr",
          data_2: "2.11 hr",
          data_3: "2.14 hr",
        },
        {
          id: "2021-02-24 08:00:00",
          data_1: "1.77 hr",
          data_2: "1.89 hr",
          data_3: "1.14 hr",
        },
        {
          id: "2021-02-24 08:00:00",
          data_1: "1.77 hr",
          data_2: "2.34 hr",
          data_3: "2.14 hr",
        },
        {
          id: "2021-02-24 08:00:00",
          data_1: "1.77 hr",
          data_2: "2.11 hr",
          data_3: "2.14 hr",
        },
        {
          id: "2021-02-24 08:00:00",
          data_1: "1.77 hr",
          data_2: "1.89 hr",
          data_3: "1.14 hr",
        },
        {
          id: "2021-02-24 08:00:00",
          data_1: "1.77 hr",
          data_2: "2.34 hr",
          data_3: "2.14 hr",
        },
        {
          id: "2021-02-24 08:00:00",
          data_1: "1.77 hr",
          data_2: "2.11 hr",
          data_3: "2.14 hr",
        },
        {
          id: "2021-02-24 08:00:00",
          data_1: "1.77 hr",
          data_2: "1.89 hr",
          data_3: "1.14 hr",
        },
        {
          id: "2021-02-24 08:00:00",
          data_1: "1.77 hr",
          data_2: "2.34 hr",
          data_3: "2.14 hr",
        },
        {
          id: "2021-02-24 08:00:00",
          data_1: "1.77 hr",
          data_2: "2.11 hr",
          data_3: "2.14 hr",
        },
        {
          id: "2021-02-24 08:00:00",
          data_1: "1.77 hr",
          data_2: "1.89 hr",
          data_3: "1.14 hr",
        },
      ],
    };
  },
};
</script>

<style scoped>
.text-gray {
  /* color: #707070; */
  font-weight: 500;
}
</style>